import * as _4 from 'lodash4';
import { IInTakeSurveyQuestionChoice } from '../../../intake_survey/builders/ap_intake_survey_question_choice_builder';

class RadioQuestionComponent {
  private questionName: string;
  private callBackWhenChoiceChanged: () => void;
  private modelForAnswer: IInTakeSurveyQuestionChoice;
  private choiceTheme: string;
  private cssClassBetweenChoices: string;
  private questionContainerClass: string;
  questionChoiceClicked(choice: IInTakeSurveyQuestionChoice, $event: any) {
    const isChecked = _4.get($event, 'detail.value');
    if (isChecked) {
      this.modelForAnswer = { ...choice };
      if (this.callBackWhenChoiceChanged) {
        this.callBackWhenChoiceChanged();
      }
    }
  }

  initialize() {
    this.choiceTheme = _4.get(this, 'choiceTheme', 'sky');
    this.cssClassBetweenChoices = _4.get(this, 'cssClassBetweenChoices', 'pts pbs');
    this.questionContainerClass = _4.get(this, 'questionContainerClass', 'text-bold h4');
  }
  $onInit() {
    this.initialize();
  }
}

angular.module('capability-ng-academic-planner').component('radioQuestionComponent', {
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/radio_question_component/radio_question_component.html',
  bindings: {
    questionName: '@',
    questionChoices: '=',
    callBackWhenChoiceChanged: '&',
    modelForAnswer: '=',
    cssClassBetweenChoices: '@?',
    choiceTheme: '@?',
    radioName: '@?',
    questionContainerClass: '@?',
    choiceSelectionDisabled: '<'
  },
  controller: RadioQuestionComponent
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/radio_question_component/radio_question_component.ts